import SidebarAndContainer from '../../../components/sidebar-and-container/sidebar-and-container.component';
import { useGlobalContext } from '../../../context/GlobalContext';

import { Pagination } from 'antd';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as Unicons from '@iconscout/react-unicons';
import Title from '../../../components/title/title.component';
import { IPastaDTO } from '../../../models/happy-code-api.model';
import { PageableResponse } from '../../../models/response.model';
import { usePastaService } from '../../../services/pasta.service';
import { Predicate } from '../../../models/predicate.model';
import { PastaContainer } from './components/PastaContainer';
import FiltrosPasta from './components/PastaContainer/pastaFiltros';
import buildUserAccessPredicate from '../../../hooks/use-build-user-acess.hook';
import { useUnidadeService } from '../../../services/unidade.service';
import { useTranslation } from 'react-i18next';

export default function MaterialDeApoio() {
  const { usuario } = useGlobalContext();
  const [data, setData] = useState<PageableResponse<IPastaDTO>>();
  const [predicate] = useState<Predicate>(new Predicate());
  const pastaService = usePastaService();
  const unidadeService = useUnidadeService();
  const { setIsGlobalLoading, unidade } = useGlobalContext();
  const { t } = useTranslation(['common', 'materiais_de_apoio'])

  const findTipoUnidadeByUnidadeId = useCallback(async (): Promise<number> => {
    return unidadeService.findById({ id: unidade?.id }).then(({ data }) => {
      return data.tipoUnidade.id;
    });
  }, [unidade]);

  const findPastas = async () => {
    setIsGlobalLoading(true);
    predicate.addOption('ativo', true);
    if (unidade?.id)
      predicate.addOption('tipoUnidade.id', await findTipoUnidadeByUnidadeId());
    const buildedPredicate = buildUserAccessPredicate(usuario, predicate);
    predicate.size = 12;
    buildedPredicate.page = predicate.page;
    buildedPredicate.size = predicate.size;
    pastaService
      .find(buildedPredicate)
      .then((response) => {
        setData(response.data);
      })
      .finally(() => setIsGlobalLoading(false));
  };

  const onPageChange = (page: number) => {
    predicate.setPage(page - 1);
    findPastas();
  };

  useEffect(() => {
    if (usuario) findPastas();
  }, [usuario, unidade]);

  return (
    <SidebarAndContainer materiaisApoio={true}>
      <Fragment>
        <div className="webinars-all-container__title-back-button">
          <Link to="/instrutor" className="button-second">
            <Unicons.UilArrowLeft />
            {t('common:back')}
          </Link>

          <Title title={t('materiais_de_apoio:title')} />
        </div>

        <div className="webinars-all-container__search-bar">
          <FiltrosPasta t={t} findPasta={findPastas} predicate={predicate} />
        </div>

        <div className="webinars-all-container__webinars-cards">
          {data?.content?.map((pasta) => (
            <PastaContainer key={pasta.id} Pasta={pasta} />
          ))}
        </div>

        <div className="d-flex-row j-center-a-center w-100 pb-50">
          <Pagination
            onChange={(page) => onPageChange(page)}
            current={data ? data.pageable.pageNumber + 1 : 1}
            total={data ? data.totalElements : 0}
            pageSize={data ? data.pageable.pageSize : 12}
          />
        </div>
      </Fragment>
    </SidebarAndContainer>
  );
}
